import Api from "../../../../../Services/Api";
import {contructQueryParam, fetchDataAsync} from "../../../../../Services/Utils";
import {HttpStatus} from "../../../../common/Constants";

export const dummyDataInventoryKSU = [
    {
        id: 1,
        kodeKSU: "HCK",
        nameKSU: "Scoopy Sporty Chrome",
        namaCategoryKSU: "BK",
        nameLocator: "Storing Lt.2 A1",
        jumlah: 4,
    }
]

export const initialFilterDataKSU = {
    kodeKSU: null,
    categoryKSU: null,
    kodeLocator: null,
    qrCode: null,
    umur: null,
}

export const initialDataKSU = {
    id: null,
    kodeKSU: null,
    nameSKU: null,
    namaCategoryKSU: null,
    nameLocator: null,
    jumlah: null,
}

export const initialSearchKSU = {
    nameKSU: null,
}

export const tableConfigKSU = [
    {
        name: "kodeKSU",
        label: "Kode KSU",
        options: {
            customBodyRender: (value) => {
                return value ? value : "-";
            },
            sort: false,
        },
    },
    {
        name: "nameKSU",
        label: "Nama KSU",
        options: {
            customBodyRender: (value) => {
                return value ? value : "-";
            },
            sort: false,
        },
    },
    {
        name: "namaCategoryKSU",
        label: "Kategori",
        options: {
            customBodyRender: (value) => {
                return value ? value : "-";
            },
            sort: false,
        },
    },
    {
        name: "nameLocator",
        label: "Locator",
        options: {
            customBodyRender: (value) => {
                return value ? value : "-";
            },
            sort: false,
        },
    },
    {
        name: "jumlah",
        label: "Jumlah",
        options: {
            customBodyRender: (value) => {
                return value ? value : "-";
            },
            sort: false,
        },
    },
];

export const pageConfigKSU = {
    home: {
        pageTitle: "KSU",
        tableConfig: tableConfigKSU,
        searchGrid: {name: "nameKSU", label: "Nama KSU"}
    },
    filter: [
        {
            type: "SimpleDDL",
            box: "search",
            name: "kodeKSU",
            label: "Kode KSU",
        },
        {
            type: "SimpleInput",
            name: "nameKSU",
            label: "Nama KSU",
            readOnly: true,
        },
        {
            type: "SimpleDDL",
            box: "search",
            name: "categoryKSU",
            label: "Kategori",
        },
        {
            type: "SimpleDDL",
            id: "select_options_filter_lcoator",
            box: "search",
            name: "kodeLocator",
            label: "Locator",
        },
        {
            type: "SimpleInput",
            id: "input_text_qr_code",
            name: "qrCode",
            label: "QR Code",
        },
        {
            type: "SimpleInput",
            id: "input_text_umur",
            name: "umur",
            label: "Umur >",
        },
    ],
    detail: {
        pageTitle: "Detail Inventory KSU",
        tableConfig: [
            {
                name: "qrCode",
                label: "QR Code",
                options: {
                    sort: true,
                },
            },
            {
                name: "umur",
                label: "Umur",
                options: {
                    sort: true,
                },
            },
        ],
        firstGrid: [
            {name: "kodeKSU", label: "Kode KSU"},
            {name: "nameKSU", label: "Nama KSU"}
        ],
        secondGrid: [
            {name: "namaCategoryKSU", label: "Kategori"},
            {name: "nameLocator", label: "Locator"}
        ],
        detailHistory: {
            pageTitle: "Riwayat Mutasi KSU",
            firstGrid: [
                {name: "kodeKSU", label: "Kode KSU"},
                {name: "nameKSU", label: "Nama KSU"}
            ],
        }
    },
    stock: {
        pageTitle: "Kartu Stock KSU",
        firstGrid: [
            {name: "kodeKSU", label: "Kode KSU"},
            {name: "nameKSU", label: "Nama KSU"}
        ],
        secondGrid: [
            {name: "namaCategoryKSU", label: "Kategori"},
            {name: "nameLocator", label: "Locator"}
        ],
        stockInfo: {
            pageTitle: "Detail Stock Info"
        }
    }
}

export const fetchDataInventoryKSU = async (setState, body) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").getAllInventoryKSUByParam(
            body && Object.keys(body).length > 0
                ? body :
                {
                    paramFilters: {},
                    page: 1,
                    limit: 5,
                }
        )

        if (response.ok) {
            setState((prevState) => ({
                ...prevState,
                dataTable: response.data.data,
                pagination: {
                    ...prevState.pagination,
                    count: response.data.totalData ? response.data.totalData : 5,
                }
            }));
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

export const fetchDataDetailInventoryKSU = async (setState, body, setError) => {
    let requestBody = null;
    if (body && Object.keys(body).length > 0) {
        requestBody = {
            kodeKSU: body.kodeKSU,
            kodeLocator: body.kodeLocator,
            kodeCabang: body.kodeCabang,
        }
    }

    let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailInventoryKSU,
        menuName: "Detail Inventory KSU",
        setError,
        args: requestBody && Object.keys(requestBody).length > 0
            ? requestBody :
            {
                paramFilters: {},
                page: 1,
                limit: 5,
            },
    });

    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        setState((prevState) => ({
            ...prevState,
            dataTable: response.data.data,
            rawDataTable: response.data.data,
            pagination:{
                ...prevState.pagination,
                count: response.data.data.length
            }
        }));
    }
}

export const fetchDataDetailHistoryInventoryKSU = async (setState, body, setError) => {
    let requestBody = null;
    if (body && Object.keys(body).length > 0) {
        requestBody = {
            qrCode: body.qrCode,
        }
    }

    let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailHistoryInventoryKSU,
        menuName: "Detail History Inventory KSU",
        setError,
        args: requestBody && Object.keys(requestBody).length > 0
            ? requestBody :
            {
                paramFilters: {},
                page: 1,
                limit: 5,
            }

    });

    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        setState((prevState) => ({
            ...prevState,
            dataTable: response.data.data,
            pagination:{
                ...prevState.pagination,
                count: response.data.data.length
            }
        }));
    }
}

export const fetchDataMasterKSU = async (setState) => {
    try {
        let response = await Api.create("NAGAMAS_MASTER_DATA").getAllKSU()
        if (response.ok) {
            setState((prevState) => ({
                ...prevState,
                dataKSUDDL: response.data.data,
            }));
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

export const fetchCardStockKSU = async (setState, body, setError) => {
    let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getKSUStockCard,
        menuName: "Kartu Stock KSU",
        setError,
        args: body,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        setState((prevState) => ({
            ...prevState,
            dataTable: res.data.data,
            pagination:{
                ...prevState.pagination,
                count: res.data.data.length
            }
        }));
    }
};

export const fetchCardStockDetailKSU = async (setState, body, setError) => {
    console.log(body);
    let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getKSUStockCardDetail,
        menuName: "Kartu Stock KSU",
        setError,
        args: body,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        setState((prevState) => ({
            ...prevState,
            dataTable: res.data.data,
            pagination:{
                ...prevState.pagination,
                count: res.data.data.length
            }
        }));
    }
};